/*
  <rk-compare-slider>: Vorher/Nachher über ein natives range-Input
  (Maus, Touch, Pfeiltasten, Pos1/Ende).
*/
if (!customElements.get('rk-compare-slider')) {
  class RkCompareSlider extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.rk-compare__range');
      if (!this.range) return;
      this.before = this.dataset.labelBefore || '';
      this.after = this.dataset.labelAfter || '';

      this.onInput = () => this.update(this.range.value);
      this.range.addEventListener('input', this.onInput);

      this.update(this.range.value);
    }

    disconnectedCallback() {
      this.range?.removeEventListener('input', this.onInput);
    }

    update(value) {
      this.style.setProperty('--rk-compare-pos', `${value}%`);
      const label = value >= 50 ? this.before : this.after;
      const share = value >= 50 ? value : 100 - value;
      this.range.setAttribute('aria-valuetext', `${share} % ${label}`);
    }
  }

  customElements.define('rk-compare-slider', RkCompareSlider);
}

if (!customElements.get('rk-compare-deck')) {
  class RkCompareDeck extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rk-compare__track');
      this.dots = Array.from(this.querySelectorAll('[data-rk-compare-dot]'));
      if (!this.track || this.dots.length < 2) return;
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const slide = this.track.children[Number(dot.dataset.rkCompareDot)];
          slide?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
      this.track.addEventListener('scroll', () => {
        const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    }
  }
  customElements.define('rk-compare-deck', RkCompareDeck);
}
